import { FoodType } from '../../../../constants/foodType';
import { Measurement } from '../../../../interfaces/Measurement';
import { foodsService } from '../../../../services/foodsService';
import { FoodFormValues } from '../../interfaces/FoodFormValues';
import { formValuesToSaveRequest } from '../formValuesToSaveRequest/formValuesToSaveRequest';

type SaveFoodParams = {
  foodType: FoodType;
  formValues: FoodFormValues;
  /** the Nutritionix food's measurements keyed by unit; null for a manual food */
  nxMeasurementsByUnit: Record<string, Measurement> | null;
  /** called once the food row exists; store the id in the form so a retry after a later failure updates it */
  onFoodIdReceived: (id: number) => void;
};

/** `POST manual` → micronutrients → tags → recommended. Not atomic: the first failure stops the chain. */
export const saveFood = async ({
  foodType,
  formValues,
  nxMeasurementsByUnit,
  onFoodIdReceived,
}: SaveFoodParams) => {
  const measurement = nxMeasurementsByUnit?.[formValues.amountUnit];

  const { id } = await foodsService.saveFood(
    foodType,
    formValuesToSaveRequest(formValues, { measurement }),
  );

  onFoodIdReceived(id);
  await foodsService.updateMicroNutrients(id, formValues.microNutrients);
  await foodsService.updateTags(
    id,
    formValues.tags.map((tag) => tag.id),
  );
  await foodsService.setRecommended(id, formValues.recommended);
};
